var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/CommonVideoPlayer/CommonVideoPlayer.jinja"] = require( "front/components/CommonVideoPlayer/CommonVideoPlayer.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/AwardsADGWinnersList/AwardsADGWinnersList.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/AwardsADGWinnersList/AwardsADGWinnersList.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
env.getTemplate("front/components/CommonVideoPlayer/CommonVideoPlayer.jinja", false, "assets/app/front/components/AwardsADGWinnersList/AwardsADGWinnersList.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "CommonVideoPlayer")) {
var t_7 = t_4.CommonVideoPlayer;
} else {
cb(new Error("cannot import 'CommonVideoPlayer'")); return;
}
context.setVariable("CommonVideoPlayer", t_7);
output += "\n\n";
var macro_t_8 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_9 = "";t_9 += "\n    <div class=\"AwardsADGWinnersList\">\n        <div class=\"AwardsADGWinnersList-categoryTitle\">";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"submissions")),0)),"category") || runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"submissions")),0)),"categoryManual"), env.opts.autoescape);
t_9 += "</div>\n        <div class=\"AwardsADGWinnersList-films\">\n            ";
frame = frame.push();
var t_12 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"submissions");
if(t_12) {t_12 = runtime.fromIterator(t_12);
var t_11 = t_12.length;
for(var t_10=0; t_10 < t_12.length; t_10++) {
var t_13 = t_12[t_10];
frame.set("film", t_13);
frame.set("loop.index", t_10 + 1);
frame.set("loop.index0", t_10);
frame.set("loop.revindex", t_11 - t_10);
frame.set("loop.revindex0", t_11 - t_10 - 1);
frame.set("loop.first", t_10 === 0);
frame.set("loop.last", t_10 === t_11 - 1);
frame.set("loop.length", t_11);
t_9 += "\n                <div class=\"AwardsADGWinnersList-film ";
if(runtime.memberLookup((t_13),"status") == "w") {
t_9 += "AwardsADGWinnersList-film--winner";
;
}
t_9 += " ";
if(env.getFilter("length").call(context, runtime.memberLookup((t_13),"episodes")) == 0 && !runtime.memberLookup((t_13),"assetsVideoCode") && !runtime.memberLookup((t_13),"assetsPresentation") && env.getFilter("length").call(context, runtime.memberLookup((t_13),"team")) < 2) {
t_9 += "AwardsADGWinnersList-film--empty";
;
}
t_9 += "\">\n                    <div class=\"AwardsADGWinnersList-filmHead\">\n                        <div class=\"AwardsADGWinnersList-filmImage\">\n                            ";
if(runtime.memberLookup((t_13),"assetsCover")) {
t_9 += "\n                                <img src=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_13),"assetsCover")),"w200_url"), env.opts.autoescape);
t_9 += "\"\n                                  srcset=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_13),"assetsCover")),"w400_url"), env.opts.autoescape);
t_9 += " 2x\"\n                                  alt=\"\">\n";
t_9 += "\n";
t_9 += "\n";
t_9 += "\n";
t_9 += "\n                            ";
;
}
else {
t_9 += "\n                                <div class=\"AwardsADGWinnersList-filmImageDefault\"></div>\n                            ";
;
}
t_9 += "\n                        </div>\n\n                        <div class=\"AwardsADGWinnersList-filmWrapper\">\n                            <div class=\"AwardsADGWinnersList-filmTable\">\n                                <div class=\"AwardsADGWinnersList-filmCell\">\n                                    ";
if(runtime.memberLookup((t_13),"status") == "w") {
t_9 += "\n                                        <div class=\"AwardsADGWinnersList-filmWinner\">Winner</div>\n                                    ";
;
}
t_9 += "\n                                    <div class=\"AwardsADGWinnersList-filmTitle\">";
t_9 += runtime.suppressValue(runtime.memberLookup((t_13),"title"), env.opts.autoescape);
t_9 += "</div>\n                                    ";
if(env.getFilter("length").call(context, runtime.memberLookup((t_13),"team"))) {
t_9 += "<div class=\"AwardsADGWinnersList-filmProductionDesigner\">\n                                        ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_13),"team")),0)),"position")) {
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_13),"team")),0)),"position"), env.opts.autoescape);
t_9 += ": ";
;
}
else {
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_13),"team")),0)),"positionManual")) {
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_13),"team")),0)),"positionManual"), env.opts.autoescape);
t_9 += ": ";
;
}
;
}
t_9 += " <span>";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_13),"team")),0)),"url")) {
t_9 += "<a href=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_13),"team")),0)),"url"), env.opts.autoescape);
t_9 += "\">";
;
}
t_9 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_13),"team")),0)),"name"), env.opts.autoescape);
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_13),"team")),0)),"url")) {
t_9 += "</a>";
;
}
t_9 += "</span>\n                                    </div>\n                                    ";
;
}
else {
if(runtime.memberLookup((t_13),"temp")) {
t_9 += "<div class=\"AwardsADGWinnersList-filmProductionDesigner\">\n                                            Head of Art Department: ";
t_9 += runtime.suppressValue(runtime.memberLookup((t_13),"tempHead"), env.opts.autoescape);
t_9 += "\n                                        </div>\n                                    ";
;
}
;
}
t_9 += "</div>\n                            </div>\n                        </div>\n\n                        <div class=\"AwardsADGWinnersList-filmCrossWrapper\">\n                            <div class=\"AwardsADGWinnersList-filmCrossTable\">\n                                <div class=\"AwardsADGWinnersList-filmCrossCell\">\n                                    <div class=\"AwardsADGWinnersList-filmCross\">\n                                        <div class=\"AwardsADGWinnersList-filmCrossV\"></div>\n                                        <div class=\"AwardsADGWinnersList-filmCrossH\"></div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n\n                    ";
if(env.getFilter("length").call(context, runtime.memberLookup((t_13),"episodes")) || env.getFilter("length").call(context, runtime.memberLookup((t_13),"team")) > 1 || runtime.memberLookup((t_13),"assetsVideoCode") || runtime.memberLookup((t_13),"assetsPresentation")) {
t_9 += "\n                    <div class=\"AwardsADGWinnersList-filmRolled\">\n                        ";
if(runtime.memberLookup((t_13),"assetsVideoCode")) {
t_9 += "\n                            <div class=\"AwardsADGWinnersList-filmRolledVideo\" ";
t_9 += ">\n                                <div class=\"AwardsADGWinnersList-filmRolledVideoWrapper\">\n                                    ";
t_9 += runtime.suppressValue((lineno = 65, colno = 54, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonVideoPlayer"), "CommonVideoPlayer", context, [runtime.makeKeywordArgs({"data": {"provider": runtime.memberLookup((t_13),"assetsVideoProvider"),"cover": runtime.memberLookup((t_13),"assetsVideoCover"),"code": runtime.memberLookup((t_13),"assetsVideoCode")},"delayed": 1})])), env.opts.autoescape);
t_9 += "\n                                </div>\n                            </div>\n";
t_9 += "\n";
t_9 += "\n";
t_9 += "\n";
t_9 += "\n";
t_9 += "\n";
t_9 += "\n";
t_9 += "\n";
t_9 += "\n";
t_9 += "\n";
t_9 += "\n";
t_9 += "\n";
t_9 += "\n                        ";
;
}
t_9 += "\n                        <div class=\"AwardsADGWinnersList-filmRolledInfo\">\n                            <div class=\"AwardsADGWinnersList-filmRolledInfoLeft\">\n\n                                <div class=\"AwardsADGWinnersList-filmRolledInfoAdditional\">\n                                    ";
if(env.getFilter("length").call(context, runtime.memberLookup((t_13),"episodes"))) {
t_9 += "\n                                        <div class=\"AwardsADGWinnersList-filmRolledInfoAdditionalEpisodes AwardsADGWinnersList-filmRolledInfoAdditionalEpisodes--";
if(env.getFilter("length").call(context, runtime.memberLookup((t_13),"team")) > 1) {
t_9 += "persons";
;
}
else {
t_9 += "no-persons";
;
}
t_9 += "\">\n                                            <p><b>Episodes:</b></p>\n                                            <p></p>\n                                            ";
frame = frame.push();
var t_16 = runtime.memberLookup((t_13),"episodes");
if(t_16) {t_16 = runtime.fromIterator(t_16);
var t_15 = t_16.length;
for(var t_14=0; t_14 < t_16.length; t_14++) {
var t_17 = t_16[t_14];
frame.set("episode", t_17);
frame.set("loop.index", t_14 + 1);
frame.set("loop.index0", t_14);
frame.set("loop.revindex", t_15 - t_14);
frame.set("loop.revindex0", t_15 - t_14 - 1);
frame.set("loop.first", t_14 === 0);
frame.set("loop.last", t_14 === t_15 - 1);
frame.set("loop.length", t_15);
t_9 += "\n                                                <p>";
t_9 += runtime.suppressValue(t_17, env.opts.autoescape);
t_9 += "</p>\n                                                <p></p>\n                                            ";
;
}
}
frame = frame.pop();
t_9 += "\n                                        </div>\n                                    ";
;
}
t_9 += "\n\n                                    ";
if((runtime.memberLookup((t_13),"assetsPresentation"))) {
t_9 += "\n                                        <p class=\"AwardsADGWinnersList-filmRolledInfoAdditionalPresentation\"><a href=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((t_13),"assetsPresentation"), env.opts.autoescape);
t_9 += "\">Design Presentation</a></p>\n                                    ";
;
}
t_9 += "\n                                </div>\n                            </div>\n\n\n                            <div class=\"AwardsADGWinnersList-filmRolledInfoRight\">\n\n                                <div class=\"AwardsADGWinnersList-filmRolledInfoAdditional\">\n                                    ";
if(env.getFilter("length").call(context, runtime.memberLookup((t_13),"episodes"))) {
t_9 += "\n                                        <div class=\"AwardsADGWinnersList-filmRolledInfoAdditionalEpisodes AwardsADGWinnersList-filmRolledInfoAdditionalEpisodes--";
if(env.getFilter("length").call(context, runtime.memberLookup((t_13),"team")) > 1) {
t_9 += "persons";
;
}
else {
t_9 += "no-persons";
;
}
t_9 += "\">\n                                            <p><b>Episodes:</b></p>\n                                            <p></p>\n                                            ";
frame = frame.push();
var t_20 = runtime.memberLookup((t_13),"episodes");
if(t_20) {t_20 = runtime.fromIterator(t_20);
var t_19 = t_20.length;
for(var t_18=0; t_18 < t_20.length; t_18++) {
var t_21 = t_20[t_18];
frame.set("episode", t_21);
frame.set("loop.index", t_18 + 1);
frame.set("loop.index0", t_18);
frame.set("loop.revindex", t_19 - t_18);
frame.set("loop.revindex0", t_19 - t_18 - 1);
frame.set("loop.first", t_18 === 0);
frame.set("loop.last", t_18 === t_19 - 1);
frame.set("loop.length", t_19);
t_9 += "\n                                                <p>";
t_9 += runtime.suppressValue(t_21, env.opts.autoescape);
t_9 += "</p>\n                                                <p></p>\n                                            ";
;
}
}
frame = frame.pop();
t_9 += "\n                                        </div>\n                                    ";
;
}
t_9 += "\n                                </div>\n\n                                <div class=\"AwardsADGWinnersList-filmRolledInfoRightPersons\">\n                                    ";
frame = frame.push();
var t_24 = env.getFilter("tail").call(context, runtime.memberLookup((t_13),"team"),1);
if(t_24) {t_24 = runtime.fromIterator(t_24);
var t_23 = t_24.length;
for(var t_22=0; t_22 < t_24.length; t_22++) {
var t_25 = t_24[t_22];
frame.set("person", t_25);
frame.set("loop.index", t_22 + 1);
frame.set("loop.index0", t_22);
frame.set("loop.revindex", t_23 - t_22);
frame.set("loop.revindex0", t_23 - t_22 - 1);
frame.set("loop.first", t_22 === 0);
frame.set("loop.last", t_22 === t_23 - 1);
frame.set("loop.length", t_23);
t_9 += "\n                                        <div class=\"AwardsADGWinnersList-filmRolledInfoRightPerson\">\n                                            <div class=\"AwardsADGWinnersList-filmRolledInfoRightPersonPosition\">";
if(runtime.memberLookup((t_25),"position")) {
t_9 += runtime.suppressValue(runtime.memberLookup((t_25),"position"), env.opts.autoescape);
;
}
else {
if(runtime.memberLookup((t_25),"positionManual")) {
t_9 += runtime.suppressValue(runtime.memberLookup((t_25),"positionManual"), env.opts.autoescape);
;
}
;
}
t_9 += "</div>\n                                            <div class=\"AwardsADGWinnersList-filmRolledInfoRightPersonName\">";
if((runtime.memberLookup((t_25),"url"))) {
t_9 += "<a href=\"";
t_9 += runtime.suppressValue(runtime.memberLookup((t_25),"url"), env.opts.autoescape);
t_9 += "\">";
;
}
t_9 += runtime.suppressValue(runtime.memberLookup((t_25),"name"), env.opts.autoescape);
if((runtime.memberLookup((t_25),"url"))) {
t_9 += "</a>";
;
}
t_9 += "</div>\n                                        </div>\n                                    ";
;
}
}
frame = frame.pop();
t_9 += "\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    ";
;
}
t_9 += "\n\n                </div>\n            ";
;
}
}
frame = frame.pop();
t_9 += "\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_9);
});
context.addExport("AwardsADGWinnersList");
context.setVariable("AwardsADGWinnersList", macro_t_8);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/AwardsADGWinnersList/AwardsADGWinnersList.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/AwardsADGWinnersList/AwardsADGWinnersList.jinja
// module id = 36
// module chunks = 0